export default __webpack_public_path__ + "static/media/infomaniak.cbe5ba0a.webp";